export default __webpack_public_path__ + "static/media/WinterSale-2023.71bb928f.jpg";